/**
 * Rich Text utilities for Contentful content
 */

/**
 * Check if Rich Text JSON contains embedded entries or assets
 * Used to determine if lazy loading of links is needed
 *
 * @param {Object} json - Rich Text JSON from Contentful
 * @returns {boolean} - True if embedded content exists
 */
export const hasEmbeddedContent = (json) => {
  if (!json?.content) return false;

  const checkNode = (node) => {
    if (node.nodeType === 'embedded-entry-block' || node.nodeType === 'embedded-asset-block') {
      return true;
    }
    if (node.content) {
      return node.content.some(checkNode);
    }

    return false;
  };

  return json.content.some(checkNode);
};
